import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UtilitaService } from '../../services/utilita.service';
import { AggiungiPersonaComponent } from '../aggiungi-persona/aggiungi-persona.component';
import { MostraNominativiComponent } from '../mostra-nominativi/mostra-nominativi.component';
import { NominativoEliminaComponent } from '../nominativo-elimina/nominativo-elimina.component';
import { UgualeDipartimentoComponent } from '../uguale-dipartimento/uguale-dipartimento.component';
import { VisualizzaDettaglioComponent } from '../visualizza-dettaglio/visualizza-dettaglio.component';
 
@Component({
  selector: 'app-richiesta-adesione',
  templateUrl: './richiesta-adesione.component.html',
  styleUrls: ['./richiesta-adesione.component.css']
})
export class RichiestaAdesioneComponent implements OnInit {
  lstPeriodi: any;
  txtPeriodo: any;
  objdettaglio: any;
  idutente: any;
  idRichiesta: any; 
  lstElencoNominativi: any;
  iddipartimento: any;
  lstElencoTipoAdesione: any
  txtTipoAdesione: string = '';
  objiscrizione: any;
  Periodo: string='';
  idTipoAdesione: string = '';

  public isEditNonMostrareCollettivo: number = 0;
  frmInserimento!: FormGroup;
  objrichiesta: any;

  isEditTabella: number = 0;

  constructor(private srvUtilita: UtilitaService, 
    private dialog: MatDialog, private router: Router,
    private snackBar: MatSnackBar, private fb: FormBuilder,) {

   

  }

  ngOnInit(): void {
    if (!this.srvUtilita.isUtenteLoggato()) {
      // this.router.navigate(['/auth/login']);
      this.router.navigate(['/accesso']);
    }

    this.frmInserimento = this.fb.group({
      idTipoAdesione: [null],
      Descrizione: [null]
    })


    this.idutente = JSON.parse(localStorage.getItem('username') || '0').idUtente;
    this.getIscrizione();

    /* this.srvUtilita.postObj('Clienti/PostRichiestaIscrizione?iIdRichiestaProfilo=' + this.idutente, "").subscribe((res: any) => {
       console.log(res);
     })*/
    this.getTipoAdesione();
    this.getPeriodi();

    this.getProfiloUtente();


    this.getRichiesta();


  }

  getTipoAdesioneRadioButton(item: any) {
    console.log(item)
    if (item == 2) {
      this.isEditTabella= 1;
    }

    if (item == 0 || item == 1) {
      this.isEditTabella = 0;
    }
  }

  getIscrizione() {
    this.idRichiesta = JSON.parse(localStorage.getItem('idRichiesta') || '0');
    if (this.idRichiesta == 0) {
      this.srvUtilita.getObj('Utenti/CreaRichiesta?iIdRichiestaProfilo=' + this.idutente).subscribe((res: any) => {
  this.objiscrizione = res
      
        this.idRichiesta = res;
    
      })
    }
    else {
      this.getListaNominativi();
      this.getTestata();
    }
  }
  getTestata() {
     //getRichiestaIscrizione(int iIdRichiesta)

      this.srvUtilita.getObj('Utenti/getRichiestaIscrizione?iIdRichiesta=' + this.idRichiesta).subscribe((res: any) => {
        this.objiscrizione = res
        this.idTipoAdesione = res.idTipoAdesione;
        this.Periodo = res.Periodo;
       // console.log('esiste richiesta', res)
      })
  }

  getRichiesta() {
    this.srvUtilita.getObj('Utenti/GetRichiesta?idRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.objrichiesta = res
      console.log(this.objrichiesta, 'objrichiesta')
    })
  }

  getPeriodi() {
    this.srvUtilita.getLista('Utenti/GetPeriodiLista?iVisibile=1').subscribe((res: any) => {
      this.lstPeriodi = res
      // console.log('atenei', res)
    })
  }

  //btnAggiungiMeStesso
  btnAggiungiMeStesso( ) {
    const obj =
    {
      idUtenteProfilo: this.idutente,
      idRichiestaProfilo: this.idRichiesta
    }
    this.srvUtilita.postObj('Clienti/AssociaNominativoAllaRichiesta', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.getListaNominativi();


    }, (err: any) => {
      this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
     // console.log(err.error.Message, 'ERRORE');
    })
  }
  btnAggiungiNominativo(row: any) { //idRichiestaIscrizioneNominativo = id
    let dialogRef: MatDialogRef<any> = this.dialog.open(AggiungiPersonaComponent, {
      width: '750px',
      disableClose: false,
      data: { idRichiesta: this.idRichiesta, row: row, idRichiestaIscrizioneNominativo: row.idRichiestaIscrizioneNominativo }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.getListaNominativi();
      })
  }

  btnUtentiConUgualeDipartimento() {
    this.iddipartimento = this.objdettaglio.idDipartimento;
  //  console.log('iddipartimento', this.iddipartimento)
    let dialogRef: MatDialogRef<any> = this.dialog.open(UgualeDipartimentoComponent, {
      width: '800px',  // width: '720px',
      disableClose: false,
      data: { idRichiesta: this.idRichiesta, idDipartimento: this.iddipartimento, idutente: this.idutente, idrichiestaiscrizione: this.objiscrizione.iIdRichiestaProfilo }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.getListaNominativi();
      })
  }


  getListaNominativi() {
    this.idutente = JSON.parse(localStorage.getItem('username') || '0').idUtente;
    this.srvUtilita.getLista('Utenti/GetElencoNominativi?iIdRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.lstElencoNominativi = res
      if (res.lenght > 1)
        this.objdettaglio.idTipoAdesione = 2;
      //se è maggiore di uno allora è collettivo


      //console.log(res, 'elenco nominativi')
    })
  }

  btnModifica() {

  }
  btnElimina(row: any) { //idRichiestaIscrizioneNominativo = id
    let dialogRef: MatDialogRef<any> = this.dialog.open(NominativoEliminaComponent, {
      width: '720px',
      disableClose: false,
      data: { row: row, idRichiesta: this.idRichiesta, idRichiestaIscrizioneNominativo: row.idRichiestaIscrizioneNominativo}
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.getListaNominativi();
      })


 }

  getProfiloUtente() {
    this.idutente = JSON.parse(localStorage.getItem('username') || '0').idUtente;
    this.srvUtilita.getObj('Utenti/GetUtentiDettaglio?idUtentiProfilo=' + this.idutente).subscribe((res: any) => {
      this.objdettaglio = res
      console.log('objdettaglio', this.objdettaglio)
      this.frmInserimento.patchValue(this.objdettaglio)
  //console.log(res, 'res objdettaglio')
    })
  }

  getTipoAdesione() {
    this.srvUtilita.getLista('Utenti/GetTipoAdesioneLista').subscribe((res: any) => {
      this.lstElencoTipoAdesione = res;
   //   console.log('tipo adesione', res)




    })
  }

  btnAvanti() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    const obj = {
      idRichiesta: this.idRichiesta,
      Periodo: objInserimento.Descrizione,
      idTipoAdesione: objInserimento.idTipoAdesione
    }

    console.log('obj richiesta adesione' , obj)

    this.srvUtilita.postObj('Utenti/PostRichiestaPeriodo', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      localStorage.setItem('idRichiesta', obj.idRichiesta);
    //  localStorage.setItem('idTipoAdesione', obj.idTipoAdesione);

      this.router.navigate(['/dashboard/richiesta-adesione/riepilogo-richiesta-adesione/'])
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })
  }

  btnVisualizza(row: any) {
    let dialogRef: MatDialogRef<any> = this.dialog.open(VisualizzaDettaglioComponent, {
      width: '770px',
      disableClose: false,
      data: { idRichiesta: this.idRichiesta, row: row, idUtente: this.idutente }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.getListaNominativi();
      })
  }

  btnMostraNominativi() {
    this.iddipartimento = this.objdettaglio.idDipartimento;
    let dialogRef: MatDialogRef<any> = this.dialog.open(MostraNominativiComponent, {
      width: '950px',  // width: '720px',
      disableClose: false,
      data: { idRichiesta: this.idRichiesta, idDipartimento: this.iddipartimento, idutente: JSON.parse(localStorage.getItem('username') || '0').idUtente, idrichiestaiscrizione: this.objiscrizione.iIdRichiestaProfilo }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.getListaNominativi();
      })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }

}
  
  
